import { HeartIcon as HeartIconOutline } from '@heroicons/react/24/outline'
import { HeartIcon as HeartIconSolid } from '@heroicons/react/24/solid'
import React from 'react'
import { cn } from '../../../Utils/component'
import { formatNumber } from '../../../Utils/formatNumber'

export const LikeButton = ({
  isLiked,
  isLoading = false,
  onClick,
  likesCount = undefined,
}: {
  isLiked: boolean
  onClick: () => void
  isLoading?: boolean
  likesCount?: number
}) => {
  const iconClassNames = 'w-6 h-6 text-lama-red transition-transform duration-200'

  return (
    <button
      className={cn(
        'inline-flex items-center px-2 py-1 rounded-full shadow-lg cursor-pointer',
        'bg-white transition-all duration-200 disabled:cursor-not-allowed md:hover:scale-110',
        {
          'animate-heartBeat': isLiked,
        })
      }
      disabled={isLoading}
      type="button"
      aria-label={isLiked ? "Je n'aime plus" : "J'aime"}
      title={isLiked ? "Je n'aime plus" : "J'aime"}
      onClick={onClick}>
      <div className="flex relative justify-center items-center">
        {isLiked ? (
          <HeartIconSolid
            className={cn(
              iconClassNames,
              'scale-110'
            )}
            aria-hidden="true" />
        ) : (
          <HeartIconOutline
            className={cn(
              iconClassNames,
              'scale-90'
            )}
            aria-hidden="true" />
        )}
      </div>
      {likesCount !== undefined && likesCount !== null && (
        <span className="font-medium tabular-nums text-night ml-1.5 mt-0.5">
          {formatNumber(likesCount)}
        </span>
      )}
    </button>
  )
}
